export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      label: '租赁信息',
      prop: 'group2',
      column: [
        {
          label: '租户类型',
          prop: 'departmentRentType',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=department_rent_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择租户类型',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '租户',
          prop: 'renterId',
          type: 'tree',
          dataType: 'string',
          dicUrl: 'api/v4ward/departmentRenter/getList',
          props: { label: 'name', value: 'id' },
          rules: [
            {
              required: true,
              message: '请选择租户',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '减免金额',
          prop: 'derateMoney',
          maxlength: 12,
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '押金金额',
          maxlength: 12,
          prop: 'deposit',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '押金编号',
          prop: 'depositNo',
          maxlength: 30,
          showWordLimit: true,
          overHidden: true,
          rules: [
            {pattern: /^[0-9a-zA-Z]*$/, message: '只允许填写字母或者数字组合'},
          ],
        },
        {
          label: '电费起码',
          maxlength: 12,
          prop: 'electricityBeginNum',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
            {
              required: true,
              message: '请输入电费起码',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '水费起码',
          maxlength: 12,
          prop: 'waterBeginNumber',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '占床位数',
          prop: 'bedUsingNum',
          maxlength: 12,
          rules: [
            { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数,且不能为0' },
            {
              required: true,
              message: '请输入占用床位数',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '入住房间',
          type: 'tree',
          search: true,
          editDisabled: true,
          dicUrl: '/api/v4ward/department/getDepartmentByPropertyNameTree',
          props: {
            label: 'propertyName',
            value: 'id',
          },
          prop: 'departmentId',
          hide: true,
          rules: [
            {
              required: true,
              message: '请选择入住房间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '室友',
          prop: 'roommateName',
          disabled: true,
        },
        {
          label: '房间租金',
          prop: 'rentAmount',
          disabled: true,
        },
        {
          label: '租用时间',
          prop: 'startDate',
          type: 'datetime',
          dataType: 'Sting',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          rules: [
            {
              required: true,
              message: '请选择时间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '划扣账户',
          prop: 'bankCardNo',
          maxlength: 20,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              message: '请输入银行卡号码',
              trigger: 'blur',
            },
            {
              min: 16,
              max: 19,
              message: '请输入最少16位最多19位号码',
            },
          ],
        },
        {
          label: '划扣银行',
          prop: 'bank',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
          props: { label: 'dictValue', value: 'dictKey' },
        },
      ],
    },
  ],
};
